var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"main-container"},[_c('side-bar',{attrs:{"isSplicingTable":true}}),_vm._v(" "),_c('main-content',{staticClass:"splicing-main-content-container",attrs:{"sidebarIsOpen":_vm.sidebarIsOpen}},[_c('SplicingTable')],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73e1bdd9","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/SplicingView.vue
// module id = null
// module chunks = 